// Hide internal editable placeholders from the public frontend.
const PLACEHOLDER_RE = /(\[|\]|düzenlenebilir|_{2,}|^—$|^-$)/i;

export function isReal(value) {
  if (value === null || value === undefined) return false;
  const v = String(value).trim();
  if (!v) return false;
  if (PLACEHOLDER_RE.test(v)) return false;
  return true;
}

// Join only real values with a separator (for project meta etc.)
export function joinReal(values, sep = " · ") {
  return values.filter(isReal).join(sep);
}
